module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-saas-trend-f7699e4ae8ad2bfd9c7c60a1d47aec14.png";